/**
 * Returns a new sorted array of 6 pictures or blank spaces
 * from the API Response.
 *
 * Gets a API Response like this:
 * [
 *  { url: 'img.jpg', position: 4 },
 *  { url: 'img.jpg', position: 2 }
 * ]
 *
 * And returns this:
 * [
 *  { url: 'fallback-image.jpg', position: 0},
 *  null,
 *  { url: 'img.jpg', position: 2 },
 *  null,
 *  { url: 'img.jpg', position: 4 }
 *  null
 * ]
 */
export const cleanPictures = (pictures, fallbackPictureUrl) => {
  const newPictures = [null, null, null, null, null, null]

  return newPictures.map((newPicture, i) => {
    // Find the picture from the response with the matching position.
    // This could return a found picture or undefined.
    const foundPicture = pictures.find(p => !!p && p.position === i)

    // If there's no matching picture on the first position, use the
    // fallback image.
    if (i === 0 && !foundPicture) {
      return { url: fallbackPictureUrl, position: 0 }
    }

    // If we found a picture for this position, we use it.
    if (foundPicture) return foundPicture

    // At this point we didn't find a matching picture, so we encountered
    // an empty slot: `null`
    return null
  })
}



// WEBPACK FOOTER //
// ./src/utils/user-utils.js